import * as React from 'react';

import { cn, TouchButton } from '@rematter/ui-web';
import { LucideTrash2 } from 'lucide-react';

import { ItemFieldProps } from '../_types';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

//
// ⚛️ ⚛️ ⚛️ DELETE BUTTON FIELD ⚛️ ⚛️ ⚛️
//
export const DeleteButtonField: React.FC<ItemFieldProps> = ({
  lineItem,
  disabled,
  onDeleteItem,
}) => {
  // Translation
  const t = useTranslations();

  // Callbacks
  const handleDelete = React.useCallback(() => {
    onDeleteItem(lineItem.id);
  }, [lineItem.id, onDeleteItem]);

  return (
    <TouchButton
      variant="ghost"
      color="failure"
      onPress={handleDelete}
      isDisabled={disabled}
      aria-label={t.scaleTicketPro.itemsInterface.deleteLineItem}
      className={cn('@DeleteButtonField', 'max-h-[44px]')}
      isSelected={false}
    >
      <LucideTrash2 size={16} />
    </TouchButton>
  );
};
